const descData = [
    {
        heading:"Hello Smart Parker",
        subHeading:"Create account & Log in to start accessing parking feature",
        description:"Secure account creation and verfiication with the help of otp",
        img:"https://images.unsplash.com/photo-1616363088386-31c4a8414858?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
    },
    {
        heading:"Hello Smart Parker",
        subHeading:"Only Verified Parking lots",
        description:"Now, choose the best parking lot for your convenience and affordability",
        img:"https://images.unsplash.com/photo-1604063165585-e17e9c3c3f0b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=869&q=80"
    },
    {
        heading:"Hello Smart Parker",
        subHeading:"Create account & Log in to start accessing parking feature",
        description:"Park comfortably on the go with large number of parking lots available",
        img:"https://images.unsplash.com/photo-1579070339603-6d4b8e1aed57?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
    }
]
export default descData;